import { forwardRef } from "react";
export const forwardRefPolymorphic = forwardRef;
